/**
 * Same AWS Cognito User Pool and CookieStorage as main Grigora app.
 * Reads id token only from cookies set by that client (CognitoIdentityServiceProvider.<clientId>.*).
 */

import { CognitoUserPool, CookieStorage } from "amazon-cognito-identity-js";

const poolId = process.env.REACT_APP_AWS_COGNITO_POOL || "";
const clientId = process.env.REACT_APP_AWS_COGNITO_CLIENT || "";
const cookieDomain = process.env.REACT_APP_AWS_COOKIE_KEY || "localhost";

let userPool = null;

function getUserPool() {
  if (!poolId || !clientId) return null;
  if (userPool) return userPool;
  try {
    const storage = new CookieStorage({
      domain: cookieDomain,
      path: "/",
      expires: 365,
      secure: window.location?.protocol === "https:",
    });
    userPool = new CognitoUserPool({
      UserPoolId: poolId,
      ClientId: clientId,
      Storage: storage,
    });
    return userPool;
  } catch {
    return null;
  }
}

/**
 * Get current Cognito id token (async). Uses same CookieStorage keys as main app.
 */
export function getIdToken() {
  return new Promise((resolve) => {
    const pool = getUserPool();
    if (!pool) {
      resolve(null);
      return;
    }
    try {
      const user = pool.getCurrentUser();
      if (!user) {
        resolve(null);
        return;
      }
      user.getSession((err, session) => {
        if (err || !session?.getIdToken?.()) {
          resolve(null);
          return;
        }
        resolve(session.getIdToken().getJwtToken());
      });
    } catch {
      resolve(null);
    }
  });
}

export function isCognitoConfigured() {
  return Boolean(poolId && clientId);
}
